import * as yup from 'yup'

export const schemaCancelServiceModal = yup.object().shape({
    service_stopped_date: yup.string().required(),
    service_reason_cancel: yup.string().required(),
})
